import axios from 'axios';

import {getApiClient} from '@zzng/common/utils/api';

import {logResponseError} from '@/shared/utils/erorrLogger';

const REQUEST_TIMEOUT_VALUE = 10000;

const instance = axios.create({timeout: REQUEST_TIMEOUT_VALUE});

instance.interceptors.response.use(undefined, logResponseError);

const apiClient = getApiClient(instance);

export const api = async <T>(...params: Parameters<typeof apiClient>) => {
  const response = await apiClient<T>(...params);
  return response.data;
};
